import { Scene, Material, PBRMetallicRoughnessMaterial, Texture } from '@babylonjs/core';
import { stringUtil } from '../stringUtil';

export interface IShader {
    diffuse: string;
    normal: string;
    avatar: string;
    text: string;
    key: string;
    getMaterial(scene: Scene, light: string): Material;
    addLight(scene: Scene, material: Material, light: string): Material;
}

export class ShaderBase {

    public addLight(scene: Scene, material: Material, light: string): Material {
        return this.addCreativeLight(material as PBRMetallicRoughnessMaterial, light, scene);
    }

    public addCreativeLight(material: PBRMetallicRoughnessMaterial, light: string, scene: Scene): Material {
        if (light) {
            const url = stringUtil.createDownloadUrl(light);
            const lightmapTexture = new Texture(url, scene);
            lightmapTexture.coordinatesIndex = 1;
            lightmapTexture.vScale = -1;
            material.useLightmapAsShadowmap = true;
            material.lightmapTexture = lightmapTexture;
        }

        return material;
    }
}